class Modal {

    constructor(modalComponent) {
        this.modalComponent = modalComponent;
        this.modalConstructor = Vue.extend(modalComponent);
        this.modal = undefined;
    }

    static show(modalComponent, config = {}) {
        // preparing the stage
        const containerEl = document.createElement('div');
        document.body.appendChild(containerEl);
        
        let instance = new Modal(modalComponent);
        document.addEventListener('keydown', instance.keyDownEventListener())
        return new Promise((resolve, reject) => {
            let modal = new instance.modalConstructor(config).$mount(containerEl);

            modal.$on('close', function (event) {
                instance.destroy();
            });

            modal.$on('resolve', function (response) {
                resolve(response);
                instance.destroy();
            });

            modal.$on('reject', function (error) {
                reject(error);
                instance.destroy();
            });

            instance.modal = modal;
        });
    }

    destroy() {
        this.modal.$destroy();
        this.modal.$el.remove();
        document.removeEventListener('keydown', this.keyDownEventListener())
    }

    keyDownEventListener() {
        let thiz = this;
        return (event) => {
            if (event.keyCode !== 27) return; // consider only escape key
            thiz.destroy();
        }
    }
}

export default Modal;